import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../../styles/theme';

// Container principal de los indicadores
export const StepIndicatorsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  marginBottom: theme.spacing(3),
  padding: `0 ${theme.spacing(2)}`,
  width: '100%',
}));

// Container de cada paso individual
export const StepIndicatorItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  flex: 1,
  maxWidth: '120px',
}));

// Círculo del indicador
export const StepCircle = styled(Box)(({ theme }) => ({
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
  transition: 'all 0.3s ease-in-out',
  position: 'relative',
  zIndex: 2,

  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

// Texto del paso
export const StepIndicatorText = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  textAlign: 'center',
  lineHeight: 1.4,
  transition: 'all 0.3s ease-in-out',
  maxWidth: '120px',
  wordWrap: 'break-word',
  fontWeight: 500,
}));

// Línea conectora entre pasos
export const StepConnector = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '28px',
  left: '50%',
  right: '-50%',
  height: '2px',
  backgroundColor: colors.grey[200],
  zIndex: 1,
  transition: 'background-color 0.3s ease-in-out',

  '&.completed': {
    backgroundColor: colors.primary.main,
  },

  '&.active': {
    backgroundColor: colors.primary.light,
  },
}));

// Variantes de tamaño
export const StepIndicatorsContainerSmall = styled(StepIndicatorsContainer)(({ theme }) => ({
  marginBottom: theme.spacing(2),

  '& .MuiBox-root': {
    width: '40px',
    height: '40px',
  },
}));

export const StepIndicatorsContainerLarge = styled(StepIndicatorsContainer)(({ theme }) => ({
  marginBottom: theme.spacing(4),

  '& .MuiBox-root': {
    width: '72px',
    height: '72px',
  },
}));

// Variantes de color
export const StepCirclePrimary = styled(StepCircle)(({ theme }) => ({
  '&.active': {
    backgroundColor: colors.primary.main,
    color: 'white',
  },
  '&.completed': {
    backgroundColor: colors.primary.light,
    color: colors.primary.dark,
  },
  '&.inactive': {
    backgroundColor: colors.grey[200],
    color: colors.grey[500],
  },
}));

export const StepCircleSuccess = styled(StepCircle)(({ theme }) => ({
  '&.active': {
    backgroundColor: colors.success.main,
    color: 'white',
  },
  '&.completed': {
    backgroundColor: colors.success.light,
    color: colors.success.dark,
  },
  '&.inactive': {
    backgroundColor: colors.grey[200],
    color: colors.grey[500],
  },
}));

export const StepCircleWarning = styled(StepCircle)(({ theme }) => ({
  '&.active': {
    backgroundColor: colors.warning.main,
    color: 'white',
  },
  '&.completed': {
    backgroundColor: colors.warning.light,
    color: colors.warning.dark,
  },
  '&.inactive': {
    backgroundColor: colors.grey[200],
    color: colors.grey[500],
  },
}));

// Animaciones
export const StepCircleAnimated = styled(StepCircle)(({ theme }) => ({
  '&.active': {
    animation: 'pulse 2s infinite',
  },

  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(59, 130, 246, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 10px rgba(59, 130, 246, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(59, 130, 246, 0)',
    },
  },
}));
